import { ChangeDetectionStrategy, Component, input, output, signal } from '@angular/core';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-event-action-panel',
  imports: [MatIcon],
  templateUrl: './event-action-panel.html',
  styleUrl: './event-action-panel.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EventActionPanel {
  readonly queueCount = input(0);
  readonly actionsDisabled = input(false);

  readonly processEvent = output<void>();
  readonly manualPatrol = output<void>();
  readonly siteCheck = output<void>();

  readonly processPressed = signal(false);
  readonly patrolPressed = signal(false);
  readonly siteCheckPressed = signal(false);

  onProcessEvent(): void {
    this.processPressed.set(true);
    this.processEvent.emit();
    setTimeout(() => this.processPressed.set(false), 200);
  }

  onManualPatrol(): void {
    this.patrolPressed.set(true);
    this.manualPatrol.emit();
    setTimeout(() => this.patrolPressed.set(false), 200);
  }

  onSiteCheck(): void {
    this.siteCheckPressed.set(true);
    this.siteCheck.emit();
    setTimeout(() => this.siteCheckPressed.set(false), 200);
  }
}
